import { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/index.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';

function getProps(route: RouteLocationNormalizedLoaded) {
  return route.query;
}

// 系统生成路由
export const routers: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      title: '登录',
    },
  },
  {
    path: '/',
    component: Layout,
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome',
    },
    meta: {
      title: '主页',
      showOnly: true,
    },
    children: [
      {
        path: 'welcome',
        component: Welcome,
        name: 'welcome',
        meta: { title: '欢迎', keepalive: false },
      },
      {
        path: 'formSysMenu',
        component: () =>
          useLayoutStore().supportColumn
            ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
            : import('@/pages/upms/formSysMenu/index.vue'),
        name: 'formSysMenu',
        meta: { title: '菜单列表', keepalive: true },
      },
      {
        path: 'formSysUser',
        component: () => import('@/pages/upms/formSysUser/index.vue'),
        name: 'formSysUser',
        meta: { title: '用户列表', keepalive: true },
      },
      {
        path: 'formSysRole',
        component: () => import('@/pages/upms/formSysRole/index.vue'),
        name: 'formSysRole',
        meta: { title: '角色管理', keepalive: true },
      },
      {
        path: 'formSysLoginUser',
        component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
        name: 'formSysLoginUser',
        meta: { title: '在线用户', keepalive: true },
      },
      {
        path: 'formSysDict',
        component: () => import('@/pages/upms/formSysDict/index.vue'),
        name: 'formSysDict',
        meta: { title: '字典管理', keepalive: true },
      },
      {
        path: 'formSysOperationLog',
        component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
        name: 'formSysOperationLog',
        meta: { title: '操作日志', keepalive: true },
      },
      {
        path: 'agreement',
        component: () => import('@/pages/agreement/index.vue'),
        name: 'agreement',
        meta: { title: '协议列表', keepalive: true },
      },
      {
        path: 'complaint',
        component: () => import('@/pages/complaint/index.vue'),
        name: 'complaint',
        meta: { title: '投诉列表', keepalive: true },
      },
      {
        path: 'contract',
        component: () => import('@/pages/contract/index.vue'),
        name: 'contract',
        meta: { title: '合同列表', keepalive: true },
      },
      {
        path: 'customer',
        component: () => import('@/pages/customer/index.vue'),
        name: 'customer',
        meta: { title: '客户列表', keepalive: true },
      },{
        path: 'employee',
        component: () => import('@/pages/employee/index.vue'),
        name: 'employee',
        meta: { title: '员工列表', keepalive: true },
      },
      // 404
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/error/404.vue'),
        name: 'NotFound',
        meta: {
          title: '404',
        },
      },
    ],
  },
  // TODO 第三方接入路由
  {
    path: '/thirdParty',
    component: () => import('@/components/thirdParty/index.vue'),
    name: 'thirdParty',
    props: getProps,
    children: [
      // 通用
      {
        path: 'thirdSelectDept',
        name: 'thirdSelectDept',
        props: getProps,
        component: () => import('@/components/DeptSelect/DeptSelectDlg.vue'),
      },
      {
        path: 'thirdSelectUser',
        name: 'thirdSelectUser',
        props: getProps,
        component: () => import('@/components/UserSelect/UserSelectDlg.vue'),
      },
      {
        path: 'thirdTableCustomQuery',
        name: 'thirdTableCustomQuery',
        props: getProps,
        component: () => import('@/components/TableBox/CustomQuery/index.vue'),
      },
      {
        path: 'thirdTableCustomConfig',
        name: 'thirdTableCustomConfig',
        props: getProps,
        component: () => import('@/components/TableBox/CustomConfig/index.vue'),
      },
    ],
  },
];
